import * as L from "leaflet";
import { GestureHandling } from "leaflet-gesture-handling";

import "leaflet/dist/leaflet.css";
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css";

delete L.Icon.Default.prototype._getIconUrl;



export const indexMap = () => {


    const indexMap = document.getElementById("mapid");
    if (!indexMap) return

    const mapInit = indexMap.getAttribute("mapInit").split(",");
    if (!mapInit) return
    const locations = indexMap.getAttribute("locations").split(",");
    if (!locations) return

    const latitudes = indexMap.getAttribute("latitude").split(",");
    if (!latitudes) return

    const longitudes = indexMap.getAttribute("longitude").split(",");
    if (!longitudes) return





    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);



    const mymap = L.map("mapid",{center: mapInit,  zoom:4, gestureHandling: true});

    L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
            attribution:'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 15,
            zoom: 7,
            id: "mapbox/streets-v11",
            tileSize: 512,
            zoomOffset: -1,
            accessToken:"pk.eyJ1IjoiZXhlaWJpZXIiLCJhIjoiY2twN2R3ZXNrMDB5ZzJ2cGNncG41eWI4NyJ9.2AYRQlVbYa8cTO9QwYcz8Q",


        }
    ).addTo(mymap);


    L.Icon.Default.mergeOptions({
        iconRetinaUrl: "/dist/img/icons/link-location.svg",
        iconUrl: "/dist/img/icons/link-location.svg",
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
    });
    const markers = []
    for (let i = 0; i < locations.length; i++) {
        let marker = new L.marker([latitudes[i], longitudes[i]])
            .bindPopup(locations[i])
            .addTo(mymap);
        markers.push([latitudes[i], longitudes[i]])
    }

    mymap.fitBounds(markers, {padding: [30, 30]})

};

export const showMap = () => {
    const showMap = document.getElementById("show-map");
    if (!showMap) return

    const mapInit = showMap.getAttribute("mapInit").split(",");
    if (!mapInit === null) return

    const locations = showMap.getAttribute("locations").split(",");
    if (!locations === null) return

    const latitudes = showMap.getAttribute("latitude");
    if (!latitudes === null) return

    const longitudes = showMap.getAttribute("longitude");
    if (!longitudes === null) return




    L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling);

    const map = L.map("show-map",{center: [latitudes, longitudes], zoom:10, gestureHandling: true});

    L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
            attribution:
                'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 15,
            zoom: 7,
            id: "mapbox/streets-v11",
            tileSize: 512,
            zoomOffset: -1,
            accessToken:
                "pk.eyJ1IjoiZXhlaWJpZXIiLCJhIjoiY2twN2R3ZXNrMDB5ZzJ2cGNncG41eWI4NyJ9.2AYRQlVbYa8cTO9QwYcz8Q"
        }
    ).addTo(map)

    L.Icon.Default.mergeOptions({
        iconRetinaUrl: '/dist/img/icons/link-location.svg',
        iconUrl: '/dist/img/icons/link-location.svg',
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      });

    const marker = L.marker([latitudes, longitudes]).addTo(map)

    map.fitBounds([latitudes, longitudes])


};
